import { useGlobalState } from "@/context/GlobalStateContext";
import React from "react";
import "./Privacy.scss";

const Privacy = () => {
  const { language } = useGlobalState();
  return (
    <>
      {language === "ru" ? (
        <div className="privacy__content">
          <h1 className="privacy__title">
            Политика конфиденциальности и обработки персональных данных Paylater
          </h1>

          <h2 className="privacy__subtitle">1. Общие положения</h2>
          <p>
            1.1. Настоящая Политика определяет порядок обработки и защиты
            информации о физических лицах (далее — Пользователи), которая может
            быть получена микрофинансовой организацией ООО МФО «PAYLATER» (далее
            — Компания) при использовании Пользователями мобильного приложения
            Paylater и/или сайта https://paylater.uz (далее — Продукты).
          </p>
          <p>
            1.2. Цель Политики — защита персональных данных Пользователей от
            несанкционированного доступа, соблюдение требований законодательства
            Республики Узбекистан.
          </p>
          <p>
            1.3. Все действия по сбору, хранению и обработке данных
            осуществляются в соответствии с настоящей Политикой, внутренними
            документами Компании и законодательством Республики Узбекистан.
          </p>
          <p>
            1.4. В случае противоречий между настоящей Политикой и другими
            внутренними документами — приоритет имеет настоящая Политика.
          </p>

          <h2 className="privacy__subtitle">
            2. Персональные данные, которые мы собираем
          </h2>
          <p>
            2.1. При использовании Продуктов могут быть запрошены и обработаны
            следующие данные:
          </p>
          <ul>
            <li>Фамилия, имя, отчество;</li>
            <li>Номер мобильного телефона;</li>
            <li>Адрес электронной почты;</li>
            <li>Паспортные/ID-данные;</li>
            <li>ИНН и другие идентификаторы;</li>
            <li>Банковские реквизиты;</li>
            <li>Геолокация;</li>
            <li>Уникальные данные устройства;</li>
            <li>Доступ к контактам и SMS (по разрешению);</li>
            <li>
              Данные, полученные при прохождении биометрической идентификации.
            </li>
          </ul>
          <p>
            2.2. Предоставляя данные, Пользователь выражает согласие на их
            обработку, хранение, использование, передачу третьим лицам в рамках
            заключённых договоров и законодательства, а также на получение
            уведомлений и рекламной информации.
          </p>
          <h2 className="privacy__subtitle">3. Биометрическая идентификация</h2>
          <p>
            3.1. В рамках предоставления финансовых услуг через мобильное
            приложение, Paylater может использовать биометрические данные
            Пользователя (например, изображение лица, голос) для:
          </p>
          <ul>
            <li>Подтверждения личности при входе и оформлении займа;</li>
            <li>
              Подписания договоров онлайн (в соответствии с требованиями
              регулятора).
            </li>
          </ul>
          <p>
            3.2. Биометрические данные обрабатываются только при наличии явного
            согласия Пользователя и не передаются третьим лицам, за исключением
            случаев, предусмотренных законом.
          </p>

          <h2 className="privacy__subtitle">4. Цели обработки данных</h2>
          <p>4.1. Обработка данных осуществляется в следующих целях:</p>
          <ul>
            <li>Предоставление услуг микрозайма и рассрочки;</li>
            <li>Отображение персонального лимита;</li>
            <li>Выполнение договорных обязательств;</li>
            <li>Обработка транзакций;</li>
            <li>Идентификация личности;</li>
            <li>Поддержка клиентов и уведомления о статусе заявок;</li>
            <li>Отправка рекламных и информационных сообщений;</li>
            <li>Проведение маркетинговых исследований;</li>
            <li>
              Исполнение требований AML/CFT и других норм законодательства.
            </li>
          </ul>

          <h2 className="privacy__subtitle">5. Порядок и условия обработки</h2>
          <p>
            5.1. Обработка персональных данных осуществляется как
            автоматизированными средствами, так и без них.
          </p>
          <p>
            5.2. Компания применяет организационные и технические меры
            безопасности, в том числе:
          </p>
          <ul>
            <li>Шифрование данных;</li>
            <li>Ограничение доступа;</li>
            <li>Ведение журналов доступа;</li>
            <li>Антивирусная защита и межсетевые экраны.</li>
          </ul>
          <p>5.3. Данные могут быть переданы:</p>
          <ul>
            <li>Уполномоченным государственным органам;</li>
            <li>Партнёрам Компании, если это необходимо для оказания услуг;</li>
            <li>Только в рамках законодательства Республики Узбекистан.</li>
          </ul>

          <h2 className="privacy__subtitle">6. Подтверждение согласия</h2>
          <p>6.1. Подтверждая регистрацию в Продуктах, Пользователь:</p>
          <ul>
            <li>Подтверждает достоверность предоставляемых данных;</li>
            <li>Ознакомлен с условиями настоящей Политики;</li>
            <li>
              Даёт согласие на сбор, хранение, обработку и передачу персональных
              данных;
            </li>
            <li>
              Согласен на получение уведомлений и рекламы любыми каналами связи.
            </li>
          </ul>
          <p>
            6.2. Проставление галочки при регистрации или входе в приложение
            означает согласие с настоящей Политикой.
          </p>

          <h2 className="privacy__subtitle">7. Изменения политики</h2>
          <p>
            7.1. Компания оставляет за собой право обновлять настоящую Политику.
            Новая редакция вступает в силу с момента публикации.
          </p>

          <h2 className="privacy__subtitle">8. Применимое право</h2>
          <p>
            8.1. Все правоотношения, возникающие в связи с применением настоящей
            Политики, регулируются законодательством Республики Узбекистан.
          </p>

          <h2 className="privacy__subtitle">
            9. Использование аналитики и сторонних сервисов
          </h2>
          <p>
            9.1. Для улучшения качества обслуживания и анализа поведения
            Пользователей Компания использует сторонние сервисы аналитики и
            атрибуции, включая Google Analytics for Firebase и AppsFlyer.
          </p>
          <p>
            9.2. Указанные сервисы могут собирать данные об устройстве
            (например, модель, версия ОС, уникальные идентификаторы и рекламный
            идентификатор), техническую информацию (IP-адрес, язык системы), а
            также информацию об использовании Продуктов (события, взаимодействия
            с экранами, установки, переходы по ссылкам).
          </p>
          <p>9.3. Собранные данные используются исключительно для целей:</p>
          <ul>
            <li>анализа работы Продуктов и повышения их качества;</li>
            <li>измерения и оптимизации маркетинговых кампаний;</li>
            <li>
              выявления технических ошибок и улучшения производительности;
            </li>
            <li>
              обеспечения безопасности и предотвращения мошеннических действий.
            </li>
          </ul>
          <p>
            9.4. Передача данных сервисам Google Analytics for Firebase и
            AppsFlyer осуществляется в зашифрованном виде. Пользователи могут
            ознакомиться с политиками конфиденциальности этих сервисов по
            ссылкам:
          </p>
          <ul>
            <li>
              – Google Privacy Policy:{" "}
              <a
                href="https://policies.google.com/privacy"
                target="_blank"
                rel="noreferrer"
              >
                https://policies.google.com/privacy
              </a>
            </li>
            <li>
              – AppsFlyer Privacy Policy:{" "}
              <a
                href="https://www.appsflyer.com/legal/privacy-policy/"
                target="_blank"
                rel="noreferrer"
              >
                https://www.appsflyer.com/legal/privacy-policy/
              </a>
            </li>
          </ul>
          <p>
            9.5. Компания не передает персональные данные Пользователей
            сторонним организациям в маркетинговых целях без отдельного согласия
            Пользователя.
          </p>
        </div>
      ) : (
        <div className="privacy__content">
          <h1 className="privacy__title">
            Paylater Maxfiylik siyosati va shaxsiy ma’lumotlarni qayta ishlash
            tartibi
          </h1>

          <h2 className="privacy__subtitle">1. Umumiy qoidalar</h2>
          <p>
            1.1. Ushbu Siyosat "PAYLATER" MChJ MFO (keyingi o‘rinlarda –
            Kompaniya) tomonidan Paylater mobil ilovasi va/yoki
            https://paylater.uz saytidan (keyingi o‘rinlarda – Mahsulotlar)
            foydalanganda jismoniy shaxslarga (keyingi o‘rinlarda –
            Foydalanuvchilar) tegishli ma’lumotlarni qayta ishlash va himoya
            qilish tartibini belgilaydi.
          </p>
          <p>
            1.2. Siyosatning maqsadi – Foydalanuvchilarning shaxsiy
            ma’lumotlarini ruxsatsiz kirishdan himoya qilish, O‘zbekiston
            Respublikasi qonunchiligi talablariga rioya qilish.
          </p>
          <p>
            1.3. Ma’lumotlarni yig‘ish, saqlash va qayta ishlash bo‘yicha barcha
            harakatlar ushbu Siyosat, Kompaniyaning ichki hujjatlari va
            O‘zbekiston Respublikasi qonunchiligiga muvofiq amalga oshiriladi.
          </p>
          <p>
            1.4. Ushbu Siyosat va boshqa ichki hujjatlar o‘rtasida ziddiyat
            bo‘lsa – ustuvorlik ushbu Siyosatga tegishli.
          </p>

          <h2 className="privacy__subtitle">
            2. Biz yig‘adigan shaxsiy ma’lumotlar
          </h2>
          <p>
            2.1. Mahsulotlardan foydalanganda quyidagi ma’lumotlar so‘ralishi va
            qayta ishlanishi mumkin:
          </p>
          <ul>
            <li>Familiya, ism, otasining ismi;</li>
            <li>Mobil telefon raqami;</li>
            <li>Elektron pochta manzili;</li>
            <li>Pasport yoki ID ma’lumotlari;</li>
            <li>INN va boshqa identifikatorlar;</li>
            <li>Bank rekvizitlari;</li>
            <li>Geolokatsiya;</li>
            <li>Qurilmaning noyob ma’lumotlari;</li>
            <li>Kontaktlar va SMS-larga ruxsat asosida kirish;</li>
            <li>Biometrik identifikatsiya jarayonida olingan ma’lumotlar.</li>
          </ul>
          <p>2.2. Ma’lumotlarni taqdim etish orqali Foydalanuvchi:</p>
          <ul>
            <li>
              Ularni qayta ishlash, saqlash, foydalanish, uchinchi shaxslarga
              qonun va shartnomalar doirasida uzatishga rozilik bildiradi;
            </li>
            <li>
              Bildirishnomalar va reklama ma’lumotlarini olishga rozilik beradi.
            </li>
          </ul>

          <h2 className="privacy__subtitle">3. Biometrik identifikatsiya</h2>
          <p>
            3.1. Moliyaviy xizmatlarni mobil ilova orqali taqdim etish
            jarayonida Paylater Foydalanuvchining biometrik ma’lumotlaridan
            (masalan, yuz tasviri, ovoz) quyidagi maqsadlarda foydalanishi
            mumkin:
          </p>
          <ul>
            <li>Shaxsni tasdiqlash (ilovaga kirish yoki qarz olishda);</li>
            <li>
              Onlayn shartnomalarni imzolash (regulyator talablari asosida).
            </li>
          </ul>
          <p>
            3.2. Biometrik ma’lumotlar faqat Foydalanuvchining aniq roziligi
            bilan qayta ishlanadi va qonunda nazarda tutilgan holatlardan
            tashqari uchinchi shaxslarga uzatilmaydi.
          </p>

          <h2 className="privacy__subtitle">
            4. Ma’lumotlarni qayta ishlash maqsadlari
          </h2>
          <p>4.1. Ma’lumotlar quyidagi maqsadlarda qayta ishlanadi:</p>
          <ul>
            <li>Mikrozaym va bo‘lib-bo‘lib to‘lash xizmatlarini ko‘rsatish;</li>
            <li>Shaxsiy limitni ko‘rsatish;</li>
            <li>Shartnomaviy majburiyatlarni bajarish;</li>
            <li>Tranzaksiyalarni amalga oshirish;</li>
            <li>Shaxsni identifikatsiya qilish;</li>
            <li>
              Foydalanuvchi qo‘llab-quvvatlash va ariza holatini xabardor
              qilish;
            </li>
            <li>Reklama va axborot xabarlarini yuborish;</li>
            <li>Marketing tadqiqotlarini o‘tkazish;</li>
            <li>AML/CFT va boshqa qonunchilik talablarini bajarish.</li>
          </ul>

          <h2 className="privacy__subtitle">
            5. Qayta ishlash tartibi va shartlari
          </h2>
          <p>
            5.1. Shaxsiy ma’lumotlarni qayta ishlash avtomatlashtirilgan va
            avtomatlashtirilmagan vositalar bilan amalga oshiriladi.
          </p>
          <p>5.2. Kompaniya quyidagi xavfsizlik choralarini qo‘llaydi:</p>
          <ul>
            <li>Ma’lumotlarni yashirish;</li>
            <li>Kirishni cheklash;</li>
            <li>Kirsh jurnallarini yuritish;</li>
            <li>Antivirus himoyasi va xavfsizlik devorlari.</li>
          </ul>
          <p>5.3. Ma’lumotlar quyidagilarga berilishi mumkin:</p>
          <ul>
            <li>Vakolatli davlat organlariga;</li>
            <li>Xizmat ko‘rsatishda zarur bo‘lganda Kompaniya hamkorlariga;</li>
            <li>Faqat O‘zbekiston Respublikasi qonunchiligi doirasida.</li>
          </ul>

          <h2 className="privacy__subtitle">6. Rozilikni tasdiqlash</h2>
          <p>6.1. Mahsulotlarda ro‘yxatdan o‘tar ekan, Foydalanuvchi:</p>
          <ul>
            <li>Taqdim etilgan ma’lumotlarning to‘g‘riligini tasdiqlaydi;</li>
            <li>Ushbu Siyosat shartlari bilan tanishganligini bildiradi;</li>
            <li>
              Shaxsiy ma’lumotlarni yig‘ish, saqlash, qayta ishlash va uzatishga
              rozilik beradi;
            </li>
            <li>
              Har qanday aloqa kanali orqali bildirishnoma va reklama olishga
              rozilik beradi.
            </li>
          </ul>
          <p>
            6.2. Ro‘yxatdan o‘tishda yoki ilovaga kirishda belgilangan belgi
            (✔) qo‘yish ushbu Siyosatga rozilik sifatida qabul qilinadi.
          </p>

          <h2 className="privacy__subtitle">7. Siyosatdagi o‘zgarishlar</h2>
          <p>
            7.1. Kompaniya ushbu Siyosatni yangilash huquqini o‘zida saqlab
            qoladi. Yangi tahrir e’lon qilingan paytdan boshlab kuchga kiradi.
          </p>

          <h2 className="privacy__subtitle">8. Qo‘llaniladigan qonun</h2>
          <p>
            8.1. Ushbu Siyosatni qo‘llash bilan bog‘liq barcha huquqiy
            munosabatlar O‘zbekiston Respublikasi qonunchiligi bilan tartibga
            solinadi.
          </p>

          <h2 className="privacy__subtitle">
            9. Analitika va uchinchi tomon servislaridan foydalanish
          </h2>
          <p>
            9.1. Xizmat sifatini yaxshilash va Foydalanuvchilar
            xatti-harakatlarini tahlil qilish maqsadida Kompaniya Google
            Analytics for Firebase va AppsFlyer kabi uchinchi tomon analitika va
            attribusiya servislaridan foydalanadi.
          </p>
          <p>
            9.2. Ushbu servislar qurilma haqida ma’lumotlarni (masalan, model,
            OS versiyasi, noyob identifikatorlar va reklamaviy identifikator),
            texnik ma’lumotlarni (IP-manzil, tizim tili) hamda Mahsulotlardan
            foydalanish haqidagi ma’lumotlarni (hodisalar, ekranlar bilan o‘zaro
            aloqalar, o‘rnatishlar, havolalar orqali o‘tishlar) yig‘ishi mumkin.
          </p>
          <p>9.3. Yig‘ilgan ma’lumotlar quyidagi maqsadlarda qo‘llaniladi:</p>
          <ul>
            <li>Mahsulotlar ishini tahlil qilish va sifatini oshirish;</li>
            <li>Marketing kampaniyalarini o‘lchash va optimallashtirish;</li>
            <li>
              Texnik xatoliklarni aniqlash va ishlash samaradorligini oshirish;
            </li>
            <li>Xavfsizlikni ta’minlash va firibgarlikni oldini olish.</li>
          </ul>
          <p>
            9.4. Google Analytics for Firebase va AppsFlyer servislariga
            uzatiladigan ma’lumotlar shifrlangan holda yuboriladi.
            Foydalanuvchilar ushbu servislarning maxfiylik siyosatlari bilan
            quyidagi havolalar orqali tanishishlari mumkin:
          </p>
          <ul>
            <li>
              – Google Privacy Policy:{" "}
              <a
                href="https://policies.google.com/privacy"
                target="_blank"
                rel="noreferrer"
              >
                https://policies.google.com/privacy
              </a>
            </li>
            <li>
              – AppsFlyer Privacy Policy:{" "}
              <a
                href="https://www.appsflyer.com/legal/privacy-policy/"
                target="_blank"
                rel="noreferrer"
              >
                https://www.appsflyer.com/legal/privacy-policy/
              </a>
            </li>
          </ul>
          <p>
            9.5. Kompaniya Foydalanuvchilarning shaxsiy ma’lumotlarini uchinchi
            tomonlarga marketing maqsadlarida alohida roziliksiz bermaydi.
          </p>
        </div>
      )}
    </>
  );
};
export default Privacy;
